import { render, staticRenderFns } from "./FixtureTagger.vue?vue&type=template&id=8285885e&scoped=true"
import script from "./FixtureTagger.vue?vue&type=script&lang=js"
export * from "./FixtureTagger.vue?vue&type=script&lang=js"
import style0 from "./FixtureTagger.vue?vue&type=style&index=0&id=8285885e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8285885e",
  null
  
)

export default component.exports